__turbopack_context__.v({
  "accordion": "RepairDetailsView-module-scss-module__uCKfjG__accordion",
  "accordionItem": "RepairDetailsView-module-scss-module__uCKfjG__accordionItem",
  "accordionPanel": "RepairDetailsView-module-scss-module__uCKfjG__accordionPanel",
  "accordionPanelInner": "RepairDetailsView-module-scss-module__uCKfjG__accordionPanelInner",
  "accordionTitle": "RepairDetailsView-module-scss-module__uCKfjG__accordionTitle",
  "accordionTrigger": "RepairDetailsView-module-scss-module__uCKfjG__accordionTrigger",
  "error": "RepairDetailsView-module-scss-module__uCKfjG__error",
  "loadingHost": "RepairDetailsView-module-scss-module__uCKfjG__loadingHost",
  "mainTitle": "RepairDetailsView-module-scss-module__uCKfjG__mainTitle",
  "moreResultsRow": "RepairDetailsView-module-scss-module__uCKfjG__moreResultsRow",
});
